var pt_br = {
    values: {
        "api key http not be empty": "chave da api web não pode ser vazia",
        "api key web": "Chave da API WEB",
        "api key web services": "Chave da API WEB Services",
    }
};

module.exports = pt_br;
